import { processAnalytics as processAnalyticsDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticsProps = {
    variant?: number,
    activity?: number,
    from?: number,
    to?: number,
    discovery_rule_id?: string,
    discovery_rule_type?: string,
    object_type: string;
    object_name: string;
    series_name: string;
};

export const processAnalytics = ({ variant, activity, from, to, discovery_rule_id, discovery_rule_type, object_type, object_name, series_name}: AnalyticsProps) => {
    processAnalyticsDiagram(variant, activity, from, to, discovery_rule_id, discovery_rule_type, object_type, object_name, series_name);
};
